import Configuration from '../components/Configuration/Configuration.vue'

let routes = {
    path: '/configuration',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/configuration',
            name: 'Configuration',
            component: Configuration,
            meta: {
              title: "Perfil",
              breadcrumb: `<li><a href="/"><i class="ti-home"></i> Configurações </a></li><li><a href="/"><i class="fa fa-cog"></i> Configuration</a></li>`
            }
        }
    ]
}


export default routes



// WEBPACK FOOTER //
// ./src/router/configuration.js